import { render } from "./Claim1_Main.vue?vue&type=template&id=c9f1cbf8&scoped=true"
import script from "./Claim1_Main.vue?vue&type=script&lang=js"
export * from "./Claim1_Main.vue?vue&type=script&lang=js"

import "./Claim1_Main.vue?vue&type=style&index=0&id=c9f1cbf8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c9f1cbf8"

export default script